import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { z } from 'zod';
import { ExpirationType, ServiceTokenFormValues } from './types';

const createSchema = (t: TFunction<readonly ['users', 'common']>, expirationType: ExpirationType) => {
  return z
    .object({
      description: z
        .string()
        .min(3, t('users:descriptionMinLength', { count: 3 }))
        .max(255, t('users:descriptionMaxLength', { count: 255 })),
      expiredAt: z.string().optional(),
    })
    .refine(
      (data) => {
        if (expirationType === 'date' && data.expiredAt) {
          return new Date(data.expiredAt) > new Date();
        }
        return true;
      },
      {
        message: t('users:dateMustBeFuture'),
        path: ['expiredAt'],
      },
    ) satisfies z.ZodType<ServiceTokenFormValues>;
};

export const useServiceTokenSchema = (expirationType: ExpirationType) => {
  const { t } = useTranslation(['users', 'common']);

  return createSchema(t, expirationType);
};
